// Tache 1465 (Eric 2026-06) — Le type REEL d'un fichier texte.
// La fiche affichait « Source : Whisper » sur un .docx : Whisper est un
// moteur de transcription audio, il n'a jamais touche ce fichier.
// Une URL n'a pas d'extension : elle se nomme par sa nature, pas par un
// point-quelque-chose qui n'existe pas.
const TYPES = {
  ".docx": "Word (.docx)",
  ".doc": "Word (.doc)",
  ".pptx": "PowerPoint (.pptx)",
  ".xlsx": "Excel (.xlsx)",
  ".pdf": "PDF",
  ".txt": "Texte (.txt)",
  ".md": "Markdown (.md)",
  ".csv": "CSV (.csv)",
  ".rtf": "RTF (.rtf)",
  ".png": "Image (.png)",
  ".jpg": "Image (.jpg)",
  ".jpeg": "Image (.jpeg)",
};

export function libelleTypeFichier(nom, sourceKind, lang = "fr") {
  if (sourceKind === "url") return lang === "fr" ? "Page web" : "Web page";
  const bas = String(nom || "").toLowerCase().split("?")[0];
  if (!bas.includes(".")) return lang === "fr" ? "Document" : "Document";
  const ext = bas.slice(bas.lastIndexOf("."));
  return TYPES[ext] || (lang === "fr" ? `Fichier (${ext})` : `File (${ext})`);
}

export default libelleTypeFichier;
